import { render, staticRenderFns } from "./DtStudentScore.vue?vue&type=template&id=2e84ea00&"
import script from "./DtStudentScore.vue?vue&type=script&lang=js&"
export * from "./DtStudentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports